import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/class-days")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/organizations/$organizationId/admin/semesters", params, replace: true });
  },
});
